// Modules
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { JobsSearchModule } from '../jobs-search/jobs-search.module';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TransferHttpCacheModule } from '@nguniversal/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// Components
import {
  AppComponent,
  CustomerScriptComponent,
  CustomerSiteComponent,
  CustomerSitePageComponent,
  CustomerSiteSectionComponent,
  CustomerSiteColumnComponent,
  CustomerSiteNotFoundComponent,
  CustomerSitePageNotFoundComponent,
  JobDetailComponent,
  JobDetailSeoComponent,
} from '../../components';

import { CustomerSiteFixedBgComponent } from 'careerpages-base/components';

// Routers
import { appRouter } from './app.routing';

// Services
import {
  HttpCacheInterceptor,
  HttpSwimlaneInterceptor,
  JobDetailResolver,
  LinkService,
  PageService,
  ReportingService,
  ServerResponseService,
  SiteService,
  FakeBackendInterceptor
} from '../../services';
import { OmnitureService } from 'careerpages-base/services/omniture.service';
import { APP_BASE_HREF } from '@angular/common';

import { environment } from '../../../environments/environment';

const extraProviders = environment.USE_MOCK_DATA ? [{ provide: HTTP_INTERCEPTORS, useClass: FakeBackendInterceptor, multi: true }] : [];

@NgModule({
  imports: [
    BrowserModule.withServerTransition({
      appId: 'career-pages'
    }),
    appRouter,
    TransferHttpCacheModule,
    BrowserAnimationsModule,
    HttpClientModule,
    SharedModule,
    JobsSearchModule
  ],
  declarations: [
    AppComponent,
    CustomerScriptComponent,
    CustomerSiteComponent,
    CustomerSitePageComponent,
    CustomerSiteSectionComponent,
    CustomerSiteColumnComponent,
    CustomerSiteNotFoundComponent,
    CustomerSitePageNotFoundComponent,
    JobDetailComponent,
    JobDetailSeoComponent,
    CustomerSiteFixedBgComponent
  ],
  exports: [AppComponent],
  providers: [
    HttpCacheInterceptor,
    HttpSwimlaneInterceptor,
    JobDetailResolver,
    LinkService,
    OmnitureService,
    PageService,
    SiteService,
    ReportingService,
    ServerResponseService,
    {
      provide: APP_INITIALIZER,
      useFactory: startupServiceFactory,
      deps: [SiteService],
      multi: true
    },
    {
      provide: APP_BASE_HREF,
      deps: [SiteService],
      useFactory: baseUrlFactory,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpCacheInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpSwimlaneInterceptor,
      multi: true
    },
    ...extraProviders
  ]
})
export class AppModule {}

// Startup service
export function startupServiceFactory(site: SiteService): Function {
  return () => site.load();
}

export function baseUrlFactory(siteService: SiteService): String {
  return siteService.getHomepagePath();
}
